import React, {useCallback} from 'react';
import {RouteComponentProps} from 'react-router-dom';
import UserCompletionState from "../common/types/UserCompletionState";
import {routes} from "../common/routes";
import { withRouter } from 'react-router-dom';

type NavigationContext = {
    navigate: (path: string, state?: object) => void,
    redirectToLogin: () => void,
    redirectToRegisterWithCompletionState: (progressionState: UserCompletionState) => void,
    redirectToGroups: () => void,
    shoppingCartUrl: string
}
export const NavigationContext = React.createContext<NavigationContext>({
    navigate: () => {},
    redirectToLogin: () => {},
    redirectToRegisterWithCompletionState: () => {},
    redirectToGroups: () => {},
    shoppingCartUrl: ''
});

interface NavigationContextProviderProps extends RouteComponentProps {
    shoppingCartUrl: string
    children: JSX.Element
}

const NavigationContextProvider: React.FC<NavigationContextProviderProps> = ({history, location, shoppingCartUrl, children}) => {
    const redirectToLogin = useCallback(() => history.push(routes.authentication + '/' + routes.authenticationSubRoutes.login + location.search), [history, location]);
    const redirectToRegisterWithCompletionState = useCallback((completionState, search: string = '') => history.push(routes.authentication + '/' + routes.authenticationSubRoutes.personalInfos + search, {userCompletionState: completionState}), [history]);
    const redirectToGroups = useCallback(() => history.push(routes.groupsAndOffers), [history]);
    return (
        <>
            <NavigationContext.Provider value={
                {
                    navigate: history.push,
                    redirectToLogin: redirectToLogin,
                    redirectToRegisterWithCompletionState: redirectToRegisterWithCompletionState,
                    redirectToGroups: redirectToGroups,
                    shoppingCartUrl: shoppingCartUrl
                }
            }>
                {children}
            </NavigationContext.Provider>
        </>
    )
};

export default withRouter(NavigationContextProvider);
